import { createContext, useContext } from 'react';
const TransitionStylesContext = /*#__PURE__*/createContext(null);
export function useTransitionStyles() {
  const context = useContext(TransitionStylesContext);
  if (!context) {
    throw new Error('useTransitionStyles must be used within a TransitionStylesProvider');
  }
  return context;
}
export default TransitionStylesContext;